import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";
import { LabelFormatSelect } from "@/components/LabelFormatSelect";
import { DEFAULT_LABEL_FORMAT } from "@/lib/labelFormat";

// Kleiner Dialog: Labelformat wählen und Aktion ausführen (Retour-Label erzeugen / Label neu abrufen)
export const LabelFormatDialog = ({ open, onOpenChange, title, description, confirmLabel, defaultFormat, onConfirm, testId = "label-format-dialog" }) => {
  const [format, setFormat] = useState(defaultFormat || DEFAULT_LABEL_FORMAT);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setFormat(defaultFormat || DEFAULT_LABEL_FORMAT); }, [open, defaultFormat]);

  const confirm = async () => {
    setBusy(true);
    try { await onConfirm(format); onOpenChange(false); } catch { /* Fehler zeigt der Aufrufer (Toast) */ } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid={testId}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        <LabelFormatSelect value={format} onChange={setFormat} testId={`${testId}-format`} />
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid={`${testId}-cancel`}>Abbrechen</Button>
          <Button onClick={confirm} disabled={busy} data-testid={`${testId}-confirm`}>{busy && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}{confirmLabel}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
